export default "/images/453bbcc68f475d1979c7f14fd2780c08.avif";